import { combineReducers } from 'redux';

import arquivoUpload from './arquivoUpload';
import auth from './auth';
import beneficiario from './beneficiario';
import contratante from './contratante';
import documento from './documento';
import lista from './lista';
import listaInativos from './listaInativos';
import listasRPA from './listasRPA';
import modalidade from './modalidade';
import parametro from './parametro';
import relatorio from './relatorio';
import requisicao from './requisicao';
import task from './task';
import termoResponsabilidade from './termoResponsabilidade';
import usuario from './usuario';
import webhookEventHeaderIntegration from './webhookEventHeaderIntegration';
import webhookEventIntegration from './webhookEventIntegration';
import webhookIntegration from './webhookIntegration';

export default combineReducers({
  auth,
  lista,
  modalidade,
  usuario,
  contratante,
  listasRPA,
  beneficiario,
  termoResponsabilidade,
  parametro,
  relatorio,
  documento,
  listaInativos,
  requisicao,
  arquivoUpload,
  task,
  webhookIntegration,
  webhookEventIntegration,
  webhookEventHeaderIntegration,
});
